/** CoStar.Api.Professional.Contacts.ContactSortType */
export var ContactSortType;
(function (ContactSortType) {
    ContactSortType[ContactSortType["None"] = 0] = "None";
    ContactSortType[ContactSortType["Address"] = 1] = "Address";
    ContactSortType[ContactSortType["City"] = 3] = "City";
    ContactSortType[ContactSortType["Name"] = 7] = "Name";
    ContactSortType[ContactSortType["JobTitle"] = 11] = "JobTitle";
    ContactSortType[ContactSortType["LeaseListings"] = 13] = "LeaseListings";
    ContactSortType[ContactSortType["LeaseTransactions3Year"] = 15] = "LeaseTransactions3Year";
    ContactSortType[ContactSortType["LocationName"] = 17] = "LocationName";
    ContactSortType[ContactSortType["PhoneNumber"] = 27] = "PhoneNumber";
    ContactSortType[ContactSortType["PrimarySpecialtyID"] = 29] = "PrimarySpecialtyID";
    ContactSortType[ContactSortType["SaleListings"] = 31] = "SaleListings";
    ContactSortType[ContactSortType["SaleTransactions3Year"] = 33] = "SaleTransactions3Year";
    ContactSortType[ContactSortType["State"] = 35] = "State";
    ContactSortType[ContactSortType["Country"] = 39] = "Country";
    ContactSortType[ContactSortType["BuildingName"] = 43] = "BuildingName";
    ContactSortType[ContactSortType["PropertyFocusType"] = 45] = "PropertyFocusType";
    ContactSortType[ContactSortType["LeaseTransactionSF3Year"] = 47] = "LeaseTransactionSF3Year";
    ContactSortType[ContactSortType["RentableBuildingSF"] = 49] = "RentableBuildingSF";
    ContactSortType[ContactSortType["LeaseListingAvailableSF"] = 51] = "LeaseListingAvailableSF";
    ContactSortType[ContactSortType["SaleTransactionSF3Year"] = 53] = "SaleTransactionSF3Year";
    ContactSortType[ContactSortType["SaleTransactionVolume3YearUSD"] = 55] = "SaleTransactionVolume3YearUSD";
    ContactSortType[ContactSortType["SaleListingSF"] = 57] = "SaleListingSF";
    ContactSortType[ContactSortType["LeaseTransactionCount"] = 59] = "LeaseTransactionCount";
    ContactSortType[ContactSortType["SaleTransactionCount"] = 61] = "SaleTransactionCount";
    ContactSortType[ContactSortType["PostalCode"] = 63] = "PostalCode";
    ContactSortType[ContactSortType["Executive"] = 65] = "Executive";
    ContactSortType[ContactSortType["ArticleCount"] = 67] = "ArticleCount";
})(ContactSortType || (ContactSortType = {}));
